.quizContainer {
	background-color: var(--bg-default);
	display: flex;
	margin: 0 auto;
	gap: 5%;
	padding: 3%;
	overflow: hidden;
	min-height: 100vh;
	& > * {
		flex: 1;
	}
}

.spinnerContainer {
	display: flex;
	justify-content: center;
	align-items: center;
}

.content {
	text-align: center;
}

.logo {
	width: 70%;
}

.textContainer {
	flex: 1;
	& > * {
		margin-bottom: 1rem;
	}
	h1 {
		text-align: left;
		font-size: 0.85rem;
		margin-top: 1.25rem;
	}
}

.startButton {
	margin-top: 30%;
	transform: scale(1.25);
}

.messageContainer {
	min-height: 100vh;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	text-align: center;
	padding: 3%;
	min-height: 100vh;
}

.messageContent {
	animation-name: quizAnim;
	animation-duration: 1s;
	position: relative;
}

.messageTitle {
	color: var(--color-primary);
	margin-bottom: 0;
}

@keyframes quizAnim {
	0% {
		transform: translateY(-100%);
		opacity: 0;
	}
	50% {
		opacity: 0;
	}
	100% {
		transform: none;
		opacity: 1;
	}
}
